import {DELETE_BANNER_START} from "../../types";

export const delete_banner = (payload) => ({
    type: DELETE_BANNER_START,
    payload,
});
